<template>
	<div>
		<page-heading>Financial Accounts
		<base-button colour="primary" custom-classes="pull-right" @click="handleCreate">New Financial Account</base-button></page-heading>
		<data-table 
			:headings="headings" 
			:data="data" 
			:columns="columns" 
			:links="links"
			:meta="meta"
			:actions-component="actionsComponent"
			:actions-config="{}"
			:formatters="formatters"
			:is-loading="isLoading"
			v-on:edit="handleEdit"
			v-on:delete="handleDelete"
			v-on:page-nav="handlePageNav"
			title="Financial Accounts" 
		/>
	</div>
</template>
<script>
import DataTable from "../ui/tables/DataTable.vue";
import api from '../../api'
import FinancialAccountsDataTableActions from "./FinancialAccountsDataTableActions.vue";
import MailTo from "../../components/ui/display/MailTo.vue"
import formatters from "../../helpers/formatters"
import PageHeading from "../ui/display/PageHeading.vue";
import BaseButton from "../forms-bs3/BaseButton.vue";
import Pagination from "../ui/display/Pagination.vue";
export default {
	components: {Pagination, BaseButton, PageHeading, DataTable, FinancialAccountsDataTableActions, MailTo},
	props: {
	},
	data: function () {
		return {
			data: [],
			meta: {},
			links: {},
			isLoading: true,
			response: null
		}
	},
	computed: {
		headings() {
			return [
				{ heading: 'Name' }, 
				{ heading: 'Account Code', customClasses: 'text-center'}, 
				{ heading: 'Type', customClasses: 'text-center'}
			]
		},
		columns() {
			return [
				{ 
					column: 'name',
				},
				{ column: 'account_code', customClasses: 'text-center'},
				{ column: 'type', customClasses: 'text-center'},
			]
		},
		actionsComponent() {
			return FinancialAccountsDataTableActions;
		},
		mailToComponent() {
			return MailTo;
		},
		
		formatters() {
			return {
				created_at: {
					callback: (the_date) => { return formatters.formatDate(the_date) },
				},
				updated_at: {
					callback: (the_date) => (new Date(the_date)).toLocaleDateString(),
				},
			}
		}
	},
	mounted() {
		console.log('Financial accounts list mounted.');
		this.loadFinancialAccounts();
	},
	methods: {
		loadFinancialAccounts(url = null) {
			api.financial_accounts.getFinancialAccounts(url)
				.then((response) => {
					console.log(response.data);
					this.data = response.data.data;
					this.links = response.data.links;
					this.meta = response.data.meta;
					this.response = response.data;
					this.isLoading = false;
				})
		},
		handleDelete(data) {
			console.log('delete', data.id)
			api.financial_accounts.deleteFinancialAccount(data.id).then(() => {
				this.loadFinancialAccounts();
			})
		},
		handleEdit(data) {
			console.log('edit', data.id)
			api.navigator.navigateToRoute(route('club.financial_accounts.edit', { domain: window.SwimManagerConfig.apiDomain, financial_account: data }))
		},
		handleCreate(data) {
			console.log('create')
			api.navigator.navigateToRoute(route('club.financial_accounts.create', { domain: window.SwimManagerConfig.apiDomain }))
		},
		handlePageNav(event) {
			console.log('You clicked nav', JSON.stringify(this.links[event]))
			this.loadFinancialAccounts(this.meta.links[event].url)
		},
		debug(message) {
			console.log('FinancialAccountsList: ' + message);
		},
		formatDate(value) {
			return `${value} formatted`;
		}
	}
}
</script>
